// The slice variable is the part of the state that you want to get loading from
//  ex. getLoadingFromState('currentUser')(state)

export default function getLoadingFromState(slice) {
  return state => Boolean(state.getIn([slice, 'loading'], false));
}
